import React, {useEffect, useState} from 'react';
import { Modal, } from 'antd';
import axios from '../Common/axios';
import InfoTable from './InfoTable';
import {riskColumnData} from './columns';
import {getFindInfoRiskListData, postSaveVaRiskData } from '../Common/api';

function InfoRisk({reportId, reportInfo}) {

    const [companyCode, setCompanyCode] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    const titleName="위험 등록";

    useEffect(() => {
        //자동조회
        if(reportId) {
            findInfoRiskListData();
        }
    }, []);

    useEffect(() => {
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
        }
    }, [reportInfo]);

    const findInfoRiskListData = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({title: "Report ID is a required."});
            return;
        }

        setIsLoading(true);
        setIsDataChange(false);
        axios.get(getFindInfoRiskListData(reportId))
            .then((response) => {

                setDataSource(response.data);
                setIsLoading(false);
                //if(response.data.totalCount == 0) {
                //    Modal.info({title: "조회된 결과가 없습니다.", okText:"닫기"});
                //} 
            })
            .catch((error) => {
                console.log("InfoDanger.js --- 47 error");
                console.dir(error);
                setIsLoading(false);
            });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveCheckList(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 등록/수정/삭제 API
    const saveCheckList = (saveData) => {

        setIsDataChange(false);
        axios.post(postSaveVaRiskData()
                        , {reportId : reportId, saveData : saveData}
                        , {logCompany : companyCode, logParam : reportId})
        .then((response) => {
            if(response.data.message == '성공적으로 처리되었습니다.') {
                Modal.info({title:titleName, content:response.data.message, okText:"Close"});
                //정상적으로 처리된 경우, 재조회
                setIsDataChange(true);
            } else {
                Modal.info({title:titleName, content:response.data, okText:"Close"});  
            }
        })
        .catch((error) => {
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });
    };

    // 정보 변경시 재조회
    useEffect(() => {
        if(isDataChange) {
            findInfoRiskListData();
        }
    }, [isDataChange]);

    // 팝업에서 업로드 후 재조회
    const onReloadHandler = () => {
        //재조회
        findInfoRiskListData();
    }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <div className='tab_content'>
                 <InfoTable
                    data={dataSource} 
                    columnData={riskColumnData}
                    reportId={reportId}
                    reportInfo={reportInfo}
                    infoType={'risk'}
                    isLoading={isLoading}
                    onClickSaveHandler={onClickSaveHandler}
                    onReloadHandler={onReloadHandler}
                    assetTypeOrg=""
                    rowIndex="risk_cd" />
            </div>
        </>
    );
}

export default InfoRisk;